<template>
  <div class="paper-exam">
    <div class="title">基本信息</div>
    <Form ref="checkin" :model="checkin" :rules="ruleCheckin" :label-width="120">
      <FormItem label="活动名称" prop="name">
        <Input
          v-model="checkin.name"
          :maxlength="30"
          placeholder="请输入活动名称，不能超过30个字"
          style="width: 400px;"
          clearable
        ></Input>
        <span style="padding-left: 10px;">{{checkin.name.length}}/30</span>
      </FormItem>
      <FormItem label="活动分类" prop="classify_ids">
        <Cascader
          :data="catagoris"
          v-model="checkin.classify_ids"
          trigger="hover"
          style="width:200px;"
          change-on-select
        ></Cascader>
      </FormItem>
      <FormItem label="活动封面" prop="indexpic">
        <UploadFile
          url="/api/public/img"
          :format="['jpg','jpeg','gif','png']"
          @onSuccess="onUploadSuccess"
        ></UploadFile>
        <div class="tip">*尺寸为 690 * 300, 请上传jpg, png格式的图片, 建议图片大小不超过2MB。</div>
        <div v-if="checkin.indexpic">
          <img :src="checkin.indexpic" style="width:138px;height:66px;" />
        </div>
      </FormItem>
      <FormItem label="活动时间" prop="checkinTime">
        <DatePicker
          type="daterange"
          placeholder="开始时间~截止时间"
          ref="checkinTime"
          v-model="checkin.checkinTime"
          @on-change="onCheckinTimeChange"
          style="width: 200px"
        ></DatePicker> <span style="margin-left:20px;">共计{{ checkin.dayDiff }}天</span>
        <div class="tips">将于开始日期的00:00开始打卡，于结束日期的23:59结束打卡 ；
          打卡时间段为打卡日期内每天00：00-23:59</div>
      </FormItem>
      <FormItem label="补卡次数" prop="allow_repair">
        最多支持
        <Input
          v-model="checkin.allow_repair"
          placeholder="请输入大于0的整数"
          style="width: 150px;"
          clearable
        ></Input>次补打卡
        <div style="tips">学员可补打卡次数，0次即为不支持补打卡，补打卡不受打卡时限限制</div>
      </FormItem>

      <FormItem label="活动介绍" prop="description">
        <Input
          v-model="checkin.description"
          type="textarea"
          :maxlength="150"
          style="width: 500px;"
          clearable
        ></Input>
      </FormItem>
      <FormItem label="分享海报" prop="share_pic">
        <UploadFile
          url="/api/public/img"
          :format="['jpg','jpeg','gif','png']"
          @onSuccess="onUploadSuccessSharePic"
        ></UploadFile>
        <div class="tip">*尺寸为 270 * 360, 请上传jpg, png格式的图片, 建议图片大小不超过2MB。</div>
        <div v-if="checkin.share_pic">
          <img :src="checkin.share_pic" style="width:270px;height:360px;" />
        </div>
      </FormItem>

      <FormItem style="text-align:center">
        <Button size="large" :to="{name: 'Questioncheckin'}">返回</Button>
        <Button
          size="large"
          style="margin: 0 15px;"
          type="primary"
          @click="submitForm('checkin')"
        >保存并返回</Button>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import UploadFile from "@/components/UploadFile.vue";
export default {
  name: "QuestionCheckinAdd",
  components: {
    UploadFile
  },
  data() {
    return {
      id: this.$route.query.id,
      checkin: {
        name: "",
        classify_id: "",
        indexpic: "",
        start_time: '',
        end_time: '',
        allow_repair: 0,
        description: '',
        share_pic: '',
        dayDiff: 0,
        checkinTime: []
      },
      ruleCheckin: {
        name: [{ required: true, message: "请输入", trigger: "blur" }],
        classify_ids: [{ required: true, message: "请选择" }],
        indexpic: [{ required: true, message: "请上传"}],
        checkinTime: [{ required: true, message: "请选择"}],
        share_pic: [{ required: true, message: "请上传", trigger: "blur"}],
        description: [{ required: true, message: "请输入", trigger: "blur"}]
      },
      catagoris: []
    };
  },
  async created() {
    let catagoris = await this.$http.get("/api/course/classify");
    this.catagoris = catagoris;

    if( this.$route.query.id ) {
      this.getCheckinInfo();
    }
  },
  methods: {
    onCheckinTimeChange(range) {
      this.checkin.checkinTime = range;
      this.checkin.start_time = range[0];
      this.checkin.end_time = range[1];

      var dateBegin = new Date(range[0]);
      var dateEnd = new Date(range[1]);
      var dateDiff = dateEnd.getTime() - dateBegin.getTime();//时间差的毫秒数
      this.checkin.dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000))+1;//计算出相差天数
    },
    onUploadSuccess(data) {
      this.checkin.indexpic = data.path;
    },
    onUploadSuccessSharePic(data) {
      this.checkin.share_pic = data.path;
    },
    submitForm(name) {
      this.$refs[name].validate(valid => {

        if (!valid) {
          return;
        } else {
          let params = {};
          for (let i in this.checkin) {
            if (i == "classify_ids") {
                params.classify_id = this.checkin.classify_ids[1] || this.checkin.classify_ids[0]
            } else {
              params[i] = this.checkin[i];
            }
          }
          if(!this.id ) {
            this.$http.post(`/api/exam/checkin`, params).then((res) => {
              this.$promiseConfirm('恭喜！您已经成功创建了新的打卡活动，别忘了添加题目哦', "提示", {
                okText: "去添加",
                cancelText: "暂时不要了",
                onCancel: async () => {
                  this.$router.push({
                    name: "QuestionCheckinManage"
                  });
                },
                onOk: async () => {
                  this.$router.push({
                    name: "QuestionCheckincCalendar",
                    query: {id: res.id,date:res.start_time }
                  });
                }
              });

              // this.$router.push({
              //   name: "QuestionCheckinManage"
              // });
            });

          }else {
            this.$http.put(`/api/exam/checkin/${this.id}`, params).then(() => {
              this.$router.push({
                name: "QuestionCheckinManage"
              });
            });
          }
      }

      });
    },

    getCheckinInfo() {
      if (!this.id) {
        return;
      }
      this.$http.get(`/api/exam/checkin/${this.id}`).then((data) => {
        this.checkin = data;
        let catagoris = [];
        for (let i = 0; i < this.catagoris.length; i++) {
          let classify = this.catagoris[i];
          if (classify.value == data.classify_id) {
            catagoris.push(classify.value);
            break;
          }
          if (classify.children) {
            let c;
            for (c = 0; c < classify.children.length; c++) {
              let child = classify.children[c];
              if (child.value == data.classify_id) {
                catagoris.push(classify.value);
                catagoris.push(child.value);
                break;
              }
            }
            if (c < classify.children.length) {
              break;
            }
          }
        }
        this.checkin.classify_ids = catagoris
        this.checkin.checkinTime = [new Date(data.start_time*1000), new Date(data.end_time*1000)]

        console.log(this.checkin.checkinTime);
        this.checkin.start_time = this.checkin.checkinTime[0];
        this.checkin.end_time = this.checkin.checkinTime[1];
        var dateBegin = new Date(this.checkin.checkinTime[0]);
        var dateEnd = new Date(this.checkin.checkinTime[1]);
        var dateDiff = dateEnd.getTime() - dateBegin.getTime();//时间差的毫秒数
        this.checkin.dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000))+1;//计算出相差天数
      });
    }
  }
};
</script>
